import axios, { AxiosResponse } from 'axios'
import { URLS } from '@assets/environment/urls'
import { authAxios } from '@shared/api/auth-instance'
import { AvatarInfo, PresignAvatarRequest, PresignAvatarResponse } from '../types/avatar'

type UploadSuccessResponse = {
	message: string
}

export class UserAvatarProxy {
	private static BASE_URL: string = URLS.MEDIA

	private static buildUrl = (path: string): string => {
		const baseUrl = this.BASE_URL.endsWith('/') ? this.BASE_URL : `${this.BASE_URL}/`
		return new URL(path, baseUrl).toString()
	}

	public static presignImage = async (
		data: PresignAvatarRequest
	): Promise<PresignAvatarResponse | null> => {
		try {
			const params = new URLSearchParams(data as Record<string, string>).toString()
			const urlWithParams = this.buildUrl(`media/secure/avatar/presign?${params}`)

			const response: AxiosResponse<PresignAvatarResponse> =
				await authAxios.post(urlWithParams)

			return response.data
		} catch (error: unknown) {
			console.error(error)
			return null
		}
	}

	public static uploadImageToS3 = async (
		presignedUrl: string,
		file: File
	): Promise<UploadSuccessResponse | null> => {
		try {
			const response: AxiosResponse<void> = await axios.put(presignedUrl, file, {
				headers: {
					'Content-Type': file.type || 'application/octet-stream',
				},
				maxContentLength: Infinity,
				maxBodyLength: Infinity,
			})

			if (response.status === 200 || response.status === 204) {
				return { message: 'Image uploaded successfully' }
			}

			return null
		} catch (error: unknown) {
			console.error(error)
			return null
		}
	}

	public static getCurrentAvatar = async (): Promise<AvatarInfo | null> => {
		try {
			const response = await authAxios.get<AvatarInfo>(
				this.buildUrl('media/secure/avatar/current')
			)
			return response.data
		} catch (e: unknown) {
			console.log('Error while getting avatar', e)
			return null
		}
	}
}
